module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.displayType === _vm.emkt.SAMPLE_DISPLAY_TYPE.DISPLAY_ICON) ? _c('div', [(_vm.materialType === _vm.emkt.MATERIAL_TYPE.CELL) ? _c('img', {
    staticClass: "sample-icon",
    attrs: {
      "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'sample/目的细胞.svg'
    }
  }) : (_vm.materialType === _vm.emkt.MATERIAL_TYPE.SAMPLE) ? _c('img', {
    staticClass: "sample-icon",
    attrs: {
      "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'sample/样本.svg'
    }
  }) : (_vm.materialType === _vm.emkt.MATERIAL_TYPE.ANTIBODY) ? _c('img', {
    staticClass: "sample-icon",
    attrs: {
      "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'sample/抗体.svg'
    }
  }) : (_vm.materialType === _vm.emkt.MATERIAL_TYPE.MEDICINE) ? _c('img', {
    staticClass: "sample-icon",
    attrs: {
      "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'sample/药物.svg'
    }
  }) : (_vm.materialType === _vm.emkt.MATERIAL_TYPE.KIT) ? _c('img', {
    staticClass: "sample-icon",
    attrs: {
      "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'sample/试剂盒.svg'
    }
  }) : (_vm.materialType === _vm.emkt.MATERIAL_TYPE.VIRUS) ? _c('img', {
    staticClass: "sample-icon",
    attrs: {
      "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'sample/病毒.svg'
    }
  }) : (_vm.materialType === _vm.emkt.MATERIAL_TYPE.PLASMID) ? _c('img', {
    staticClass: "sample-icon",
    attrs: {
      "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'sample/质粒.svg'
    }
  }) : (_vm.materialType === _vm.emkt.MATERIAL_TYPE.PRIMER) ? _c('img', {
    staticClass: "sample-icon",
    attrs: {
      "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'sample/引物.svg'
    }
  }) : _c('img', {
    staticClass: "sample-icon",
    attrs: {
      "src": _vm.emkt.MATERIAL_STATIC_FILE_BASE_URL + 'sample/其它.svg'
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.displayType === _vm.emkt.SAMPLE_DISPLAY_TYPE.DISPLAY_NMAE) ? _c('div', [(_vm.displayStatusName === '待寄出') ? _c('div', {
    staticClass: "mod5",
    staticStyle: {
      "background": "rgba(255, 148, 0, 0.15)"
    }
  }, [_c('span', {
    staticClass: "txt2",
    staticStyle: {
      "color": "rgba(255, 148, 0, 1)"
    }
  }, [_vm._v(_vm._s(_vm.displayStatusName))])]) : (_vm.displayStatusName === '已寄出') ? _c('div', {
    staticClass: "mod5",
    staticStyle: {
      "background": "rgba(254, 101, 77, 0.15)"
    }
  }, [_c('span', {
    staticClass: "txt2",
    staticStyle: {
      "color": "rgba(254, 101, 77, 1)"
    }
  }, [_vm._v(_vm._s(_vm.displayStatusName))])]) : (_vm.displayStatusName === '已到达' || _vm.displayStatusName === '已到齐') ? _c('div', {
    staticClass: "mod5",
    staticStyle: {
      "background": "#EAF7F0"
    }
  }, [_c('span', {
    staticClass: "txt2",
    staticStyle: {
      "color": "#67C08C"
    }
  }, [_vm._v(_vm._s(_vm.displayStatusName))])]) : _c('div', {
    staticClass: "mod5",
    staticStyle: {
      "background": "rgba(255, 148, 0, 0.15)"
    }
  }, [_c('span', {
    staticClass: "txt2",
    staticStyle: {
      "color": "rgba(255, 148, 0, 1)"
    }
  }, [_vm._v(_vm._s(_vm.displayStatusName))])])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4074e541","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views_v_2.6/Material/DisplayIconAndStatus.vue
// module id = 1612
// module chunks = 8